import { objectToQueryString } from "../helpers/ApiHelper";
import { IApplication } from "../models/IApplication";
import { IRole, IRoleRequest } from "../models/IRole";
import { IUserRoleGroup, IUserRoleGroupResponse, IUserRoleGroupSearchParams } from "../models/IUserRoleGroup";
import * as Utils from "../utils/Config";
import { ApiClient, IPaginatedResponse } from "./ApiClient";

export class UserRoleGroupApi extends ApiClient {
    
    searchUserRoleGroups(searchParams: IUserRoleGroupSearchParams, success: (data: IPaginatedResponse<IUserRoleGroupResponse>) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getPaginated<IUserRoleGroupResponse>(`${Utils.MEN_PORTAL_API_BASE_URL}/userRoleGroups/searchUserRoleGroups?${queryString}`, success, undefined, final);
    }

    getApplications(success: (data: IApplication[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.MEN_PORTAL_API_BASE_URL}/userRoleGroups/getApplications`, success, error, final);
    }

    getRolesByApplicationId(applicationId: number, success: (data: IRole[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.MEN_PORTAL_API_BASE_URL}/userRoleGroups/getRolesByApplicationId/${applicationId}`, success, error, final);
    }

    getRolesByRoleRequest(roleRequest: IRoleRequest, success: (data: IRole[]) => void, error?: (message: string) => void, final?: () => void) {
        this.postWithResponse(`${Utils.MEN_PORTAL_API_BASE_URL}/userRoleGroups/getRolesByRoleRequest`, roleRequest, success, error, final);
    }

    getUserRoleGroupById(userRoleGroupId: number, success: (data: IUserRoleGroup) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IUserRoleGroup>(`${Utils.MEN_PORTAL_API_BASE_URL}/userRoleGroups/${userRoleGroupId}`, success, error, final);
    }

    getCreateUserRoleGroupImpactMessage(data: IUserRoleGroup, success: (data: string) => void, error?: (message: string) => void, final?: () => void) {
        this.postWithResponse(`${Utils.MEN_PORTAL_API_BASE_URL}/userRoleGroups/getCreateUserRoleGroupImpactMessage`, data, success, error, final);
    }

    createUserRoleGroup(data: IUserRoleGroup, success: (userRoleGroupId: number) => void, error?: (message: string) => void, final?: () => void) {
        this.postWithResponse(`${Utils.MEN_PORTAL_API_BASE_URL}/userRoleGroups`, data, success, error, final);
    }

    updateUserRoleGroup(data: IUserRoleGroup, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.put(`${Utils.MEN_PORTAL_API_BASE_URL}/userRoleGroups`, data, success, error, final);
    }
}

